module.exports = __webpack_public_path__ + "img/download2.fb3a453b.svg";